import { useState, useEffect, useCallback, useRef } from "react";
import { fetchItems } from "@/lib/api";

export function useCollection(resource, params = {}) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const paramsKey = JSON.stringify(params);
  const mounted = useRef(true);

  useEffect(() => {
    mounted.current = true;
    setLoading(true);
    fetchItems(resource, params)
      .then((data) => { if (mounted.current) setItems(Array.isArray(data) ? data : []); })
      .catch(() => { if (mounted.current) setItems([]); })
      .finally(() => { if (mounted.current) setLoading(false); });
    return () => { mounted.current = false; };
  }, [resource, paramsKey]); // eslint-disable-line

  const prepend = useCallback((item) => {
    setItems((prev) => [item, ...prev]);
  }, []);

  const refresh = useCallback(() => {
    setLoading(true);
    fetchItems(resource, params)
      .then((data) => setItems(Array.isArray(data) ? data : []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, [resource, paramsKey]); // eslint-disable-line

  return { items, loading, prepend, refresh };
}
